module.exports = __webpack_public_path__ + "img/Info.bce42158.svg";